<script>
  import Header from "lib/components/Header.svelte";
  import { fetchWithSession } from "lib/util/fetchWithSession.js";
  import { isValidRegex } from "lib/util/regex.js";
  import {
    Modal,
    DataTable,
    Pagination,
    DataTableSkeleton,
  } from "carbon-components-svelte";
  import { TextInput, Button } from "paxray-components-svelte";
  import { EDIT_ICON } from "@utils/icons.js";

  export let idproject;
  export let analysisid;

  let applications = [];
  let caseidrules = [];

  let caseidrule = {
    id: 0,
    rulename: "",
    applicationname: "",
    search: "",
    replace: "",
  };

  async function getApplications() {
    const res = await fetchWithSession(
      `/api/damprojects/getAnonymizationLog?idproject=${idproject}&projectStep=2`,
    );
    const text = await res.json();
    applications = text;
  }

  function getCasedIdRules() {
    fetchWithSession(`/api/analysis/getCaseIdRules?analysisid=` + analysisid)
      .then((res) => res.json())
      .then((data) => {
        caseidrules = data;
      });
  }

  function saveRule() {
    fetchWithSession(`/api/analysis/addCaseIdRule`, {
      method: "POST",
      body: JSON.stringify({
        id: caseidrule.id,
        rulename: caseidrule.rulename,
        applicationname: caseidrule.applicationname,
        search: caseidrule.search,
        replace: caseidrule.replace,
        analysisid: analysisid,
      }),
    }).then((res) => {
      if (res.ok) {
        caseidmodalOpen = false;
        getCasedIdRules();
      }
    });
  }

  function openCaseIdModal(rule) {
    if (rule) caseidrule = rule;
    else
      caseidrule = {
        id: 0,
        rulename: "",
        applicationname: "",
        search: "",
        replace: "",
      };
    caseidmodalOpen = true;
  }

  $: {
    getApplications();
    getCasedIdRules();
  }

  let pageData = 1;
  let pageSizeData = 10;
  let caseidmodalOpen = false;
  let isSaveDisabled = true;

  $: {
    isSaveDisabled = !isValidRegex(caseidrule.search);
  }

  let filteredApplications = [];
  let appsearch = "";
  let windowtitlesearch = "";

  function filterApps(app, appsearch, windowsearch) {
    let matches = true;
    if (appsearch)
      matches =
        matches &&
        app.applicationname.toLowerCase().includes(appsearch.toLowerCase());
    if (windowsearch && isValidRegex(windowsearch))
      matches = matches && app.name.match(new RegExp(windowsearch));

    return matches;
  }

  $: {
    filteredApplications = applications.filter((app) =>
      filterApps(app, appsearch, windowtitlesearch),
    );
  }

  function runCaseIdPreprocessing() {
    fetchWithSession(`/api/analysis/runCaseIdPreprocessing`, {
      method: "POST",
      body: JSON.stringify({
        analysisid: analysisid,
      }),
    }).then((res) => {
      if (res.ok) {
        alert("Object preprocessing started");
      }
    });
  }
</script>

<Header section="Preprocessing" breadcrumb="Object Preprocessing">
  <Button
    on:click={() => openCaseIdModal(0)}
    text="Add Rule"
    kind="secondary"
  />
</Header>

<DataTable
  size="short"
  headers={[
    { key: "rulename", value: "Rule Name" },
    { key: "applicationname", value: "Application" },
    { key: "search", value: "search" },
    { key: "replace", value: "replace" },
    { key: "actions", empty: true },
  ]}
  rows={caseidrules}
  sortable
>
  <svelte:fragment slot="cell" let:cell let:row>
    {#if cell.key === "actions"}
      <Button
        kind="secondary"
        icon={EDIT_ICON}
        on:click={() => openCaseIdModal(row)}
      />
    {:else}
      {cell.value}
    {/if}
  </svelte:fragment>
</DataTable>

<Modal
  id="addCaseIdRule"
  modalHeading="Add Object Rule"
  preventCloseOnClickOutside
  bind:open={caseidmodalOpen}
  primaryButtonText="Add"
  secondaryButtonText="Cancel"
  primaryButtonDisabled={isSaveDisabled}
  on:click:button--secondary={() => {
    caseidmodalOpen = false;
  }}
  on:close={() => {
    caseidmodalOpen = false;
  }}
  on:submit={saveRule}
>
  <TextInput
    id="rulename"
    labelText="Rule Name"
    bind:value={caseidrule.rulename}
  />
  <TextInput
    id="applicationname"
    labelText="Application"
    bind:value={caseidrule.applicationname}
  />
  <TextInput id="search" labelText="Search" bind:value={caseidrule.search} />
  <TextInput id="replace" labelText="Replace" bind:value={caseidrule.replace} />
</Modal>
<table>
  <tr>
    <td>
      <TextInput
        id="appsearch"
        labelText="Application"
        bind:value={appsearch}
        placeholder="Search for application"
      />
    </td>
    <td>
      <TextInput
        id="windowtitlesearch"
        labelText="Window Title"
        bind:value={windowtitlesearch}
        placeholder="Search for window title"
      />
    </td>
  </tr>
</table>
<DataTable
  size="short"
  headers={[
    { key: "applicationname", value: "Application" },
    { key: "name", value: "Window Title" },
    { key: "total", value: "Count" },
  ]}
  rows={filteredApplications}
  sortable
  page={pageData}
  pageSize={pageSizeData}
/>
<Pagination
  totalItems={filteredApplications.length}
  pageSizes={[10, 25, 50, 100]}
  bind:page={pageData}
  bind:pageSize={pageSizeData}
/>

<Button
  on:click={runCaseIdPreprocessing}
  text="Run Object Preprocessing"
  kind="secondary"
/>
